export enum CreditPullTier {
  TIER_1 = 'TIER_1',
  TIER_2 = 'TIER_2',
  TIER_3 = 'TIER_3',
}

export const creditPullTierLabel: Record<CreditPullTier, string> = {
  [CreditPullTier.TIER_1]: 'Tier 1',
  [CreditPullTier.TIER_2]: 'Tier 2',
  [CreditPullTier.TIER_3]: 'Tier 3',
};

export interface LenderTierAssignment {
  tpoName: string;
  currentTier: CreditPullTier;
  recommendedTier: CreditPullTier;
}

export interface CreditPullTierSettings {
  tier: CreditPullTier;
  includedPulls: number;
  unitPrice: number;
}

export interface LenderCreditPullTierHistory {
  historyId: number;
  lenderId: number;
  oldTier: CreditPullTier;
  newTier: CreditPullTier;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
}

export interface LenderCreditPullTierDetail {
  lenderId: number;
  lenderName: string;
  currentTier: CreditPullTier;
  history: LenderCreditPullTierHistory[];
}
